<template>
    <b-row class="reconciliation-summary-cards">
        <b-col md="3" v-for="card in cards" :key="card.label">
            <Molded>
                <span class="reconciliation-summary-cards-label">{{ card.label }}</span>
                <div class="reconciliation-summary-cards-value" :class="card.valueClass">
                    {{ card.total | currency }}
                </div>
                <div class="reconciliation-summary-cards-subtext">
                    {{ card.count }} {{ card.count == 1 ? 'item' : 'itens' }}
                </div>
            </Molded>
        </b-col>
    </b-row>
</template>
<script>

import Molded from "@/ui/layout/Molded";

export default {
    name: "ReconciliationSummaryCards",
    components: { Molded },
    props: {
        statementPayableTotal: { type: Number, default: 0 },
        statementPayableCount: { type: Number, default: 0 },
        statementReceivableTotal: { type: Number, default: 0 },
        statementReceivableCount: { type: Number, default: 0 },
        recordPayableTotal: { type: Number, default: 0 },
        recordPayableCount: { type: Number, default: 0 },
        recordReceivableTotal: { type: Number, default: 0 },
        recordReceivableCount: { type: Number, default: 0 },
    },
    computed: {
        cards() {
            return [
                {
                    label: "Extrato - Pagar",
                    total: this.statementPayableTotal,
                    count: this.statementPayableCount,
                    valueClass: "reconciliation-summary-cards-value-danger",
                },
                {
                    label: "Extrato - Receber",
                    total: this.statementReceivableTotal,
                    count: this.statementReceivableCount,
                    valueClass: "reconciliation-summary-cards-value-success",
                },
                {
                    label: "Lançamentos - Pagar",
                    total: this.recordPayableTotal,
                    count: this.recordPayableCount,
                    valueClass: "reconciliation-summary-cards-value-danger",
                },
                {
                    label: "Lançamentos - Receber",
                    total: this.recordReceivableTotal,
                    count: this.recordReceivableCount,
                    valueClass: "reconciliation-summary-cards-value-success",
                },
            ];
        },
    },
};
</script>
<style scoped>
.reconciliation-summary-cards {
    margin-bottom: 16px;
}

.reconciliation-summary-cards-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--text-secondary);
}

.reconciliation-summary-cards-value {
    font-size: 20px;
    font-weight: 600;
    color: var(--text-primary);
    margin-top: 6px;
}

.reconciliation-summary-cards-value-success {
    color: var(--color-success);
}

.reconciliation-summary-cards-value-danger {
    color: var(--color-danger);
}

.reconciliation-summary-cards-subtext {
    font-size: 12px;
    color: var(--text-secondary);
    margin-top: 2px;
}
</style>
